import { useDashboardServices } from './useDashboardServices';

export function useScreenshotService(){
  const context = useDashboardServices();

  return context.screenshotService!;
}